import { ICartItem } from './components/CartItem/CartItem';

const downloadCsv = (cart: ICartItem[]) => {
  const csv_data = ['Article;CMMF;Quantity;Availability;Notes'];

  for (const row of cart) {
    let csvrow: string[] = [
      row.article_number,
      row.cmmf,
      row.count.toString(),
      row.status === 'active' ? 'Yes' : 'No',
      row.comment ? row.comment : '',
    ];
    csv_data.push(csvrow.join(';'));
  }

  const csv_data_arr = csv_data.join('\n');
  const CSVFile = new Blob(['\ufeff', csv_data_arr], {
    type: 'text/csv; charset=utf-8;',
  });

  let link = document.createElement('a');
  link.download = 'seb_cart.csv';
  let url = window.URL.createObjectURL(CSVFile);
  link.href = url;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadCsv;
